export const CourseAssignTypes = {
    ASSIGN_COURSE_START: 'ASSIGN_COURSE_START',
    ASSIGN_COURSE_SUCCESS: 'ASSIGN_COURSE_SUCCESS',
    ASSIGN_COURSE_FAILURE: 'ASSIGN_COURSE_FAILURE'
}